export enum ErrorCode {
  VALIDATION_ERROR = "VALIDATION_ERROR",
  NAME_TAKEN = "NAME_TAKEN",
  INVALID_PARENT = "INVALID_PARENT",
  INVALID_ADDITIONAL_DISPLAY_AREA = "INVALID_ADDITIONAL_DISPLAY_AREA",
  INVALID_MANAGER = "INVALID_MANAGER",
  INVALID_MEMBER = "INVALID_MEMBER",
  MEMBER_CANNOT_BE_SUBORDINATE_OF_MANAGER = "MEMBER_CANNOT_BE_SUBORDINATE_OF_MANAGER",
  MANAGER_CANNOT_BE_INHERITED = "MANAGER_CANNOT_BE_INHERITED",
  ADDRESS_TAKEN = "ADDRESS_TAKEN",
}
